import { registerComponent, createMessage, loading } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "add-to-registry",
  class AddToRegistry extends WYATTElement {
    constructor() {
      super();

      this.form = this.querySelector("form");

      if (WYATT.shopify.customer.registryID) {
        this.setup();
      } else {
        loading.add(this);

        WYATT.storingRegistryID.then(this.setup.bind(this));
      }
    }

    get formData() {
      return new FormData(this.form);
    }

    get variant() {
      return this.formData.get("variant");
    }

    get quantity() {
      return this.formData.get("quantity");
    }

    get product() {
      return this.formData.get("product");
    }

    setup() {
      loading.remove(this);

      this.registryID = WYATT.shopify.customer.registryID;

      this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }

    handleSubmit(event) {
      event.preventDefault();

      loading.add(this);
      this.addToRegistry();
    }

    async addToRegistry() {
      const endpoint = `/apps/giftregistry/api/registry/${this.registryID}/product`;

      const response = await fetch(endpoint, this.fetchOptions());

      if (response.ok) {
        this.handleSuccess();
      } else {
        this.handleFailure();
      }

      loading.remove(this);
    }

    handleSuccess() {
      createMessage(
        `${WYATT.t.addToRegistry.addSuccess}. <a href="/apps/giftregistry/registry/${this.registryID}">${WYATT.t.addToRegistry.goToRegistry}</a>.`,
        { type: "success" },
      );
      this.pushAddToRegistry();
    }

    handleFailure() {
      let message = `${WYATT.t.addToRegistry.noRegistry}. <a href="/apps/giftregistry/create">${WYATT.t.addToRegistry.create}</a>.`;

      if (this.registryID) {
        message = WYATT.t.addToRegistry.addFail;
      }

      createMessage(message, { type: "error" });
    }

    fetchOptions() {
      return {
        method: "POST",
        body: JSON.stringify({
          products: [
            {
              id: this.product,
              variants: [
                {
                  id: this.variant,
                  quantity: this.quantity,
                },
              ],
            },
          ],
        }),
      };
    }

    pushAddToRegistry() {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: "add_to_registry",
        registry_id: this.registryID,
        product_handle: this.config.product.handle,
        product_id: this.config.product.id,
        product_title: this.config.product.title,
        page_location: window.location.href,
      });
    }
  },
);
